<template>
  <v-col class="register default-slot" md="7" sm="12">
    <add-person-modal
      :affiliatePeople="affiliatePeople"
      :affiliatePeopleDialog="affiliatePeopleDialog"
      :toggleAffiliatePeopleDialog="toggleAffiliatePeopleDialog"
      :changeAffiliatePeople="changeAffiliatePeople"
    />
    <v-dialog v-model="memberRuleDialog" width="500px">
      <v-card class="search-modal">
        <h2>Officer/Member/Director rules</h2>
        <ul class="text-left">
          <li>
            The person submitting this request must be one of the people added as President, Affiliate Rep, or Primary Show Coordinator.
          </li>
          <li>
            At least 10 officers/directors/members must be added.
          </li>
          <li>
            1 president, 1 affiliate representative, and 1 vice president must be added.
          </li>
          <li>
            1 secretary & 1 treasurer must be added, but these positions can be held by the same person. Select the "Secretary & Treasurer" option if you want one person to hold both of these positions.
          </li>
          <li>
            At least 1 primary show coordinator must be added. Up to 2 additional show coordinators may be added.
          </li>
          <li>
            All affiliate officers & directors must be full, active ASCA members.
          </li>
          <li>
            Affiliate members may be active full or service ASCA members.
          </li>
        </ul>
      </v-card>
    </v-dialog>
    <v-dialog v-if="showObligations" v-model="ascaObligationsDialog">
      <v-card class="search-modal">
        <h2>ASCA Obligations</h2>
        <ol class="text-left">
          <li>
            ASCA shall send correspondence pertaining to the Affiliate Club to
            the Affiliate Representative. ASCA shall:
            <ol>
              <li>
                Accept and submit any business flowing between ASCA and the
                Affiliate Representative
              </li>
              <li>
                Upon request, furnish the Affiliate Representative with a copy
                of ASCA Rules, literature and forms for their use. All ASCA
                rulebooks and forms are available to the Affiliate at
                www.asca.org.
              </li>
              <li>
                Be responsible for relaying pertinent ASCA information to the
                Affiliate Representative
              </li>
            </ol>
          </li>
          <li>
            ASCA shall give affiliate members the opportunity to participate in
            committee assignments that affect the general membership or breed.
          </li>
          <li>
            ASCA shall not allow any ASCA Officer or Director to give special
            consideration to any one Affiliate Club.
          </li>
          <li>
            A copy of the club's Bylaws will be supplied to the Affiliate
            Representative when approved by the ASCA BoD. The club is required
            to use these Bylaws for one year before making any changes.
          </li>
        </ol>
      </v-card>
    </v-dialog>
    <v-dialog v-if="showAscaObligations" v-model="ascaAffiliateObligationsDialog">
      <v-card class="search-modal">
        <h2>ASCA Affiliate Applicant's Obligations</h2>
        <ol class="text-left">
          <p class="font-italic">
            ELIGIBILITY: Affiliation shall be open to any club with ten
            individual ASCA members who feel they can adequately carry out
            duties of an Affiliate Club. These ten individuals must be ASCA full
            or service members. All officers and directors of the Club must be
            full ASCA members in good standing.
          </p>
          <p class="font-italic">
            ELECTION TO AFFILIATE: Each club wishing to affiliate will apply on
            the formal application supplied by ASCA. Each club will supply ASCA
            with a club membership application, officer and membership list and
            the current year's affiliation fee. The application for affiliation
            shall be sent to the Executive Secretary, who will distribute it to
            the Board of Directors for approval/disapproval after verifying the
            membership status of individual club members. Approval of the
            affiliation request requires an affirmative vote by a majority of
            the voting Directors. The Executive Secretary will send a notice of
            the vote results to the applicant club within forty-five (45) days
            of the completion of voting with the Club Bylaws. For a disapproved
            application the Executive Secretary will return the application to
            the club within forty-five (45) days of the completion of voting
            with an explanation for the disapproval. A club receiving a
            disapproved application may resubmit its application with necessary
            revisions within thirty days of receipt of the notice of
            disapproval.
          </p>
          <li>
            ASCA Affiliates shall pay annual affiliate dues to ASCA, as fixed by
            the Board of Directors, by the 31st of December of each year. All
            Affiliate Clubs will be notified on January 31st, of expiration of
            the deadline for renewal. Letters will be sent to the club President
            and Affiliate Representative, if they are not in the same household,
            giving them the final renewal deadline of February 15th. A renewal
            not received by February 15th, constitutes a lapse of affiliation.
            Lapsed affiliates will be terminated and must re-apply using the new
            Affiliate application process.
          </li>
          <li>
            ASCA Affiliates shall maintain the office of Affiliate
            Representative. The Affiliate Representative is a club officer. The
            Affiliate Representative shall:
            <ol>
              <li>
                Be a full member in good standing of ASCA and the Affiliate
                Club.
              </li>
              <li>
                Accept and submit all business flowing between ASCA and the
                Affiliate.
              </li>
              <li>
                Maintain a current copy of ASCA rules and literature (available
                at www.asca.org).
              </li>
            </ol>
          </li>
        </ol>
      </v-card>
    </v-dialog>
    <div class="top-icons">
      <a
        class="back-icon"
        v-on:click="
          changePage(1);
          changeAffiliatePeople(affiliatePeople);
        "
      >
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
      </a>
    </div>
    <h1 class="register-title mb-3">{{title}}</h1>
    <p v-if="showAscaObligations" class="mt-3">
      <a v-on:click="toggleAscaObligations()">ASCA's Obligations</a> <br />
    </p>
    <p v-if="showObligations" class="mt-3">
      <a v-on:click="toggleAscaAffiliateObligations()"
        >ASCA Affiliate Applicant's Obligations</a
      >
      <br />
    </p>
    <p class="mt-3">
      <a v-on:click="toggleMemberRuleDialog()"
        >View officer/director/member rules</a
      >
    </p>
    <v-form>
      <v-row>
        <v-col class="font-weight-bold"> Position </v-col>
        <v-col class="font-weight-bold"> Person Name </v-col>
        <v-col class="font-weight-bold"> Member ID </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row v-for="(person, idx) in affiliatePeople" :key="idx">
        <v-col>
          <v-select
            v-model="person.position"
            :items="person.memberType === 5 ? ['Member'] :
              availablePositions.indexOf(person.position) === -1 &&
              person.position !== ''
                ? [...availablePositions, person.position]
                : availablePositions
            "
            label="Position"
            :rules="[(v) => !!v || 'Position is required']"
            single-line
          ></v-select>
        </v-col>
        <v-col> {{ person.firstName }} {{ person.lastName }} </v-col>
        <v-col>
          {{ person.memberId }}
        </v-col>
      </v-row>
      <div class="mt-2">
        <a v-on:click="toggleAffiliatePeopleDialog()">
          <font-awesome-icon icon="plus" />
          Add/Edit affiliate members/officers/directors
        </a>
      </div>
    </v-form>
    <v-btn
      class="white--text mt-2"
      large
      v-on:click="
        changeAffiliatePeople(affiliatePeople);
        changePage(3);
      "
      :disabled="!isValid"
      color="primary"
      >NEXT</v-btn
    >
    <p class="steps">STEP <b>2</b> OF <b>3</b></p>
    <footer-text />
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";

import { UserInfo } from "@/types/User";
import { availablePositions, myPossibleRequiredPosistions, isValid } from "@/helpers/validate-affiliate";

import AddPersonModal from "@/components/common/AddPersonModal.vue";
import FooterText from "@/components/common/FooterText.vue";

export default Vue.extend({
  name: "AffiliateMembers",
  components: {
    AddPersonModal,
    FooterText,
  },
  props: {
    title: String,
    changePage: Function,
    affiliatePeople: Array,
    changeAffiliatePeople: Function,
    membershipTypes: Object,
    showObligations: Boolean,
    showAscaObligations: Boolean,
  },
  data: function () {
    return {
      ascaObligationsDialog: false,
      ascaAffiliateObligationsDialog: false,
      affiliatePeopleDialog: false,
      memberRuleDialog: false,
    };
  },
  methods: {
    toggleAscaObligations: function () {
      this.$data.ascaObligationsDialog = !this.$data.ascaObligationsDialog;
    },
    toggleAscaAffiliateObligations: function () {
      this.$data.ascaAffiliateObligationsDialog =
        !this.$data.ascaAffiliateObligationsDialog;
    },
    toggleAffiliatePeopleDialog: function () {
      this.$data.affiliatePeopleDialog = !this.$data.affiliatePeopleDialog;
    },
    toggleMemberRuleDialog: function () {
      this.$data.memberRuleDialog = !this.$data.memberRuleDialog;
    },
  },
  computed: {
    userInfo(): UserInfo {
      return (this as any).$store.state.userInfo;
    },
    availablePositions() {
      return availablePositions((this as any).$props.affiliatePeople);
    },
    isValid() {
      const myPosistions = (this as any).$props.affiliatePeople.filter(
          (person: { personId: number }) => person.personId === (this as any).userInfo.personId);

      // user submitting request is one of the members in the list and is assigned one of the possible required posistions?
      if (!myPosistions.length || !(myPosistions.some((mp: any) => !!myPossibleRequiredPosistions.find(rp => rp === mp.position))))
        return false;

      return isValid(this.$props.affiliatePeople);
    },
  },
});
</script>